import { gql } from "graphql-tag"

const homeVideo = gql`
  type HomeVideo {
    "Created At"
    createdAt: String!
    "Editions"
    editions: [String]
    "Id"
    id: ID!
    "Images"
    images: [Image]
    "Screenshots"
    screenshots: [Image]
    "Is Blu-ray?"
    isBluRay: Boolean!
    "Is it Published"
    isPublished: Boolean!
    "Is UHD?"
    isUHD: Boolean!
    "Label"
    label: Label
    "MAS Data"
    mas: MAS
    "Name"
    name: String
    "Number of linked News entries"
    newsCount: Int!
    "Published At"
    publishedAt: String
    "Release Date"
    releaseDate: String
    "Store Links IDs"
    storeLinks: [StoreLink]
    "TechSpecs"
    techSpecs: [[TechSpec!]]
    "Updated At"
    updatedAt: String!
  }

  """
  Minimal review metadata surfaced in search results to signal review presence
  without fetching the full HomeVideoReview payload (id/isPublished/publishedAt only).
  """
  type HomeVideoSearchItemHomeVideoReview {
    "Home Video Review Id"
    id: ID!
    "Is the review published"
    isPublished: Boolean!
    "Published At"
    publishedAt: String
  }

  type HomeVideoSearchItem {
    "Editions"
    editions: [String]
    "Is Blu-ray?"
    isBluRay: Boolean!
    "Is UHD?"
    isUHD: Boolean!
    id: ID!
    images: [Image]
    mas: MASSearchItem
    name: String!
    "Number of linked News entries"
    newsCount: Int!
    "Review metadata"
    homeVideoReview: HomeVideoSearchItemHomeVideoReview
  }

  type HomeVideoAddResponse {
    "Status"
    status: String!
  }

  input HomeVideoUpdateInput {
    "Editions"
    editions: [String]
    "Images"
    images: [ImageUpdateInput]
    "Screenshots"
    screenshots: [ScreenshotUpdateInput]
    "Is Blu-ray?"
    isBluRay: Boolean
    "Is it Published"
    isPublished: Boolean
    "Is UHD?"
    isUHD: Boolean
    "Label Id"
    labelId: ID
    "MAS Id"
    masId: ID
    "Name"
    name: String
    "Release Date"
    releaseDate: String
    "Tech Specs"
    techSpecs: [[String]]
  }

  input HomeVideoAddInput {
    "Editions"
    editions: [String]
    "Images"
    images: [ImageUpdateInput]
    "Screenshots"
    screenshots: [ScreenshotUpdateInput]
    "IMDb ID"
    imdbId: String
    "Is Blu-ray?"
    isBluRay: Boolean!
    "Is it Published"
    isPublished: Boolean!
    "Is UHD?"
    isUHD: Boolean!
    "Label Id"
    labelId: ID
    "MAS Id"
    masId: ID
    "Name"
    name: String!
    "Release Date"
    releaseDate: String
    "Tech Specs"
    techSpecs: [[String]]
  }

  input GetQueryHomeVideos {
    createdAt: String
    dateLimit: String
    isPublished: Boolean
    limit: Int
    sortBy: String
  }

  input SearchHomeVideosInput {
    isUHD: Boolean
    title: String
  }
`

export default homeVideo
